import { useQuery } from "@tanstack/react-query";
import { pppService } from "@/services/pppService";
import { priorityService } from "@/services/priorityService";

/** ponytail: one page; the detail page shows every deliverable, so 200 covers any real PPP. */
const PPP_DETAIL_LIMIT = 200;

export const usePpp = (pid?: string) =>
  useQuery({
    queryKey: ["ppps", pid],
    queryFn: () => pppService.getPpp(pid as string),
    enabled: !!pid,
  });

/** Committed deliverables linked to this PPP (has a DRI). */
export const usePppDeliverables = (pid?: string) =>
  useQuery({
    queryKey: ["priorities", "by-ppp", pid, "committed"],
    queryFn: () => priorityService.getPriorities({ pppPids: [pid as string], candidate: false, page: 1, limit: PPP_DETAIL_LIMIT }),
    enabled: !!pid,
  });

/** Candidates linked to this PPP (missing a DRI). */
export const usePppCandidates = (pid?: string) =>
  useQuery({
    queryKey: ["priorities", "by-ppp", pid, "candidates"],
    queryFn: () => priorityService.getPriorities({ pppPids: [pid as string], candidate: true, page: 1, limit: PPP_DETAIL_LIMIT }),
    enabled: !!pid,
  });
